import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

const STORAGE_KEY_PREFIX = 'courtclic:last-active-hour:';
const reportsInFlight = new Map();

export const getActivityHourKey = (date = new Date()) =>
  date.toISOString().slice(0, 13);

const getStorage = () => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

const toFirestoreTimestamp = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return firebase.firestore.Timestamp.fromDate(date);
};

export const getAccountMetadata = (user) => ({
  createdAt: toFirestoreTimestamp(user?.metadata?.creationTime),
  lastLoginAt: toFirestoreTimestamp(user?.metadata?.lastSignInTime)
});

export const reportHourlyActivity = async (
  user,
  storage = getStorage(),
  hourKey = getActivityHourKey()
) => {
  if (!user?.uid) return { recorded: false, skipped: true };

  const storageKey = `${STORAGE_KEY_PREFIX}${user.uid}`;
  if (storage?.getItem(storageKey) === hourKey) {
    return { recorded: false, skipped: true };
  }

  if (reportsInFlight.has(user.uid)) {
    return reportsInFlight.get(user.uid);
  }

  const db = firebase.firestore();
  const userRef = db.collection('users').doc(user.uid);
  const metadata = getAccountMetadata(user);

  const reportPromise = db
    .runTransaction(async (transaction) => {
      const snapshot = await transaction.get(userRef);
      const existing = snapshot.exists ? snapshot.data() : {};

      if (
        existing.lastActiveHour === hourKey &&
        existing.createdAt &&
        existing.lastLoginAt
      ) {
        return false;
      }

      const activity = {
        lastActiveAt: firebase.firestore.FieldValue.serverTimestamp(),
        lastActiveHour: hourKey
      };

      if (!existing.createdAt && metadata.createdAt) {
        activity.createdAt = metadata.createdAt;
      }
      if (metadata.lastLoginAt) {
        activity.lastLoginAt = metadata.lastLoginAt;
      }

      if (snapshot.exists) {
        transaction.update(userRef, activity);
      } else {
        transaction.set(userRef, {
          ...activity,
          accountType: 'free',
          email: user.email || '',
          ...(user.displayName ? { displayName: user.displayName } : {}),
          ...(user.photoURL ? { photoURL: user.photoURL } : {})
        });
      }

      return true;
    })
    .then((recorded) => {
      storage?.setItem(storageKey, hourKey);
      return {
        recorded,
        skipped: !recorded
      };
    })
    .finally(() => {
      reportsInFlight.delete(user.uid);
    });

  reportsInFlight.set(user.uid, reportPromise);
  return reportPromise;
};
